module.exports = __webpack_public_path__ + "static/borrowed-6df7e3e98438a72b653e8d5de596ea0a.gif";